import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const ERROR_MESSAGES: Record<string, string> = {
  not_authorized: 'Your Discord ID is not in the whitelist. Contact a server administrator.',
  oauth_failed: 'OAuth failed. Please try again.',
  access_denied: 'You cancelled the Discord sign-in.',
};

export function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get('error');
  const errorMessage = error ? (ERROR_MESSAGES[error] ?? error) : null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <Card className="w-[400px]">
        <CardHeader>
          <div className="mb-2 flex items-center gap-3">
            <img src="/favicon.svg" alt="" className="h-10 w-10" />
            <CardTitle className="text-2xl">Raynex</CardTitle>
          </div>
          <CardDescription>Discord server admin panel</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {errorMessage && (
            <div className="rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive">
              {errorMessage}
            </div>
          )}
          <Button asChild className="w-full">
            <a href="/api/auth/discord">Sign in with Discord</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
